import React from 'react';
import classNames from 'classnames';

const className = (active: boolean) =>
  classNames({
    'sl-multi-cam-cam-icon': true,
    'sl-multi-cam-cam-icon--nintuple': true,
    'sl-multi-cam-cam-icon--active': !!active,
  });

const Inactive = () => (
  <g id="Group-3" transform="translate(1.000000, 1.000000)" fillRule="nonzero">
    <rect
      id="Rectangle-16"
      stroke="#0058B0"
      strokeWidth="2"
      x="0"
      y="0"
      width="38"
      height="27"
      rx="2"
    />
    <path
      d="M3.5,3 L11.5,3 C11.7761424,3 12,3.22385763 12,3.5 L12,7.8 C12,8.07614237 11.7761424,8.3 11.5,8.3 L3.5,8.3 C3.22385763,8.3 3,8.07614237 3,7.8 L3,3.5 C3,3.22385763 3.22385763,3 3.5,3 Z M15,3 L23,3 C23.2761424,3 23.5,3.22385763 23.5,3.5 L23.5,7.8 C23.5,8.07614237 23.2761424,8.3 23,8.3 L15,8.3 C14.7238576,8.3 14.5,8.07614237 14.5,7.8 L14.5,3.5 C14.5,3.22385763 14.7238576,3 15,3 Z M26.5,3 L34.5,3 C34.7761424,3 35,3.22385763 35,3.5 L35,7.8 C35,8.07614237 34.7761424,8.3 34.5,8.3 L26.5,8.3 C26.2238576,8.3 26,8.07614237 26,7.8 L26,3.5 C26,3.22385763 26.2238576,3 26.5,3 Z M3.5,10.8 L11.5,10.8 C11.7761424,10.8 12,11.0238576 12,11.3 L12,15.6 C12,15.8761424 11.7761424,16.1 11.5,16.1 L3.5,16.1 C3.22385763,16.1 3,15.8761424 3,15.6 L3,11.3 C3,11.0238576 3.22385763,10.8 3.5,10.8 Z M15,10.8 L23,10.8 C23.2761424,10.8 23.5,11.0238576 23.5,11.3 L23.5,15.6 C23.5,15.8761424 23.2761424,16.1 23,16.1 L15,16.1 C14.7238576,16.1 14.5,15.8761424 14.5,15.6 L14.5,11.3 C14.5,11.0238576 14.7238576,10.8 15,10.8 Z M26.5,10.8 L34.5,10.8 C34.7761424,10.8 35,11.0238576 35,11.3 L35,15.6 C35,15.8761424 34.7761424,16.1 34.5,16.1 L26.5,16.1 C26.2238576,16.1 26,15.8761424 26,15.6 L26,11.3 C26,11.0238576 26.2238576,10.8 26.5,10.8 Z M3.5,18.7 L11.5,18.7 C11.7761424,18.7 12,18.9238576 12,19.2 L12,23.5 C12,23.7761424 11.7761424,24 11.5,24 L3.5,24 C3.22385763,24 3,23.7761424 3,23.5 L3,19.2 C3,18.9238576 3.22385763,18.7 3.5,18.7 Z M15,18.7 L23,18.7 C23.2761424,18.7 23.5,18.9238576 23.5,19.2 L23.5,23.5 C23.5,23.7761424 23.2761424,24 23,24 L15,24 C14.7238576,24 14.5,23.7761424 14.5,23.5 L14.5,19.2 C14.5,18.9238576 14.7238576,18.7 15,18.7 Z M26.5,18.7 L34.5,18.7 C34.7761424,18.7 35,18.9238576 35,19.2 L35,23.5 C35,23.7761424 34.7761424,24 34.5,24 L26.5,24 C26.2238576,24 26,23.7761424 26,23.5 L26,19.2 C26,18.9238576 26.2238576,18.7 26.5,18.7 Z"
      id="Combined-Shape"
      fill="#0058B0"
    />
  </g>
);

const Active = () => (
  <g id="Group-3-Copy" transform="translate(1.000000, 1.000000)" fillRule="nonzero">
    <rect
      id="Rectangle-16"
      stroke="#0058B0"
      strokeWidth="2"
      fill="#0058B0"
      x="0"
      y="0"
      width="38"
      height="27"
      rx="2"
    />
    <path
      d="M3.5,3 L11.5,3 C11.7761424,3 12,3.22385763 12,3.5 L12,7.8 C12,8.07614237 11.7761424,8.3 11.5,8.3 L3.5,8.3 C3.22385763,8.3 3,8.07614237 3,7.8 L3,3.5 C3,3.22385763 3.22385763,3 3.5,3 Z M15,3 L23,3 C23.2761424,3 23.5,3.22385763 23.5,3.5 L23.5,7.8 C23.5,8.07614237 23.2761424,8.3 23,8.3 L15,8.3 C14.7238576,8.3 14.5,8.07614237 14.5,7.8 L14.5,3.5 C14.5,3.22385763 14.7238576,3 15,3 Z M26.5,3 L34.5,3 C34.7761424,3 35,3.22385763 35,3.5 L35,7.8 C35,8.07614237 34.7761424,8.3 34.5,8.3 L26.5,8.3 C26.2238576,8.3 26,8.07614237 26,7.8 L26,3.5 C26,3.22385763 26.2238576,3 26.5,3 Z M3.5,10.8 L11.5,10.8 C11.7761424,10.8 12,11.0238576 12,11.3 L12,15.6 C12,15.8761424 11.7761424,16.1 11.5,16.1 L3.5,16.1 C3.22385763,16.1 3,15.8761424 3,15.6 L3,11.3 C3,11.0238576 3.22385763,10.8 3.5,10.8 Z M15,10.8 L23,10.8 C23.2761424,10.8 23.5,11.0238576 23.5,11.3 L23.5,15.6 C23.5,15.8761424 23.2761424,16.1 23,16.1 L15,16.1 C14.7238576,16.1 14.5,15.8761424 14.5,15.6 L14.5,11.3 C14.5,11.0238576 14.7238576,10.8 15,10.8 Z M26.5,10.8 L34.5,10.8 C34.7761424,10.8 35,11.0238576 35,11.3 L35,15.6 C35,15.8761424 34.7761424,16.1 34.5,16.1 L26.5,16.1 C26.2238576,16.1 26,15.8761424 26,15.6 L26,11.3 C26,11.0238576 26.2238576,10.8 26.5,10.8 Z M3.5,18.7 L11.5,18.7 C11.7761424,18.7 12,18.9238576 12,19.2 L12,23.5 C12,23.7761424 11.7761424,24 11.5,24 L3.5,24 C3.22385763,24 3,23.7761424 3,23.5 L3,19.2 C3,18.9238576 3.22385763,18.7 3.5,18.7 Z M15,18.7 L23,18.7 C23.2761424,18.7 23.5,18.9238576 23.5,19.2 L23.5,23.5 C23.5,23.7761424 23.2761424,24 23,24 L15,24 C14.7238576,24 14.5,23.7761424 14.5,23.5 L14.5,19.2 C14.5,18.9238576 14.7238576,18.7 15,18.7 Z M26.5,18.7 L34.5,18.7 C34.7761424,18.7 35,18.9238576 35,19.2 L35,23.5 C35,23.7761424 34.7761424,24 34.5,24 L26.5,24 C26.2238576,24 26,23.7761424 26,23.5 L26,19.2 C26,18.9238576 26.2238576,18.7 26.5,18.7 Z"
      id="Combined-Shape"
      fill="#FFFFFF"
    />
  </g>
);

const NintupleCamIcon = ({ active = false }: { active: boolean }) => (
  <svg
    className={className(active)}
    width="40px"
    height="29px"
    viewBox="0 0 40 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      {active ? <Active /> : <Inactive />}
    </g>
  </svg>
);

export default NintupleCamIcon;
